// extracted by mini-css-extract-plugin
module.exports = {"row":"SimpleQuestionBuilderModal_row__1zW8s","radioRow":"SimpleQuestionBuilderModal_radioRow__1G12H"};